// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-pal";
import { GuidanceTopicType, IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { WorkflowModes } from "services/WorkflowModes/WorkflowModes";

export class StreamingGuidanceCatalog {
    static StreamingOverviewModule: IGuidanceTopic = {
        name: "Streaming_Overview",
        modulePath: PLATFORM.moduleName("guidance/Streaming/Overview.html"),
        title: "Streaming",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoRealTimeRecording),
        topicType: GuidanceTopicType.TopicOverview,
        topicContent: "Streaming Help",
    };
    static StreamingGS1Module: IGuidanceTopic = {
        name: "Streaming_Q1", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720175701/S1+When+should+I+use+the+streaming+section
        modulePath: PLATFORM.moduleName("guidance/Streaming/S1WhenToStream.html"),
        title: "Streaming",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoRealTimeRecording),
        topicParent: StreamingGuidanceCatalog.StreamingOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "When should I use the streaming section?",
        catchwords: ["setting up measurement setup", "demo’s", "first quick analysis"],
    };

    static StreamingGS2Module: IGuidanceTopic = {
        name: "Streaming_Q2", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720175711/S2+How+to+use+the+Sound+Level+Meter+tool
        modulePath: PLATFORM.moduleName("guidance/Streaming/S2HowToUse.html"),
        title: "Streaming",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoRealTimeRecording),
        topicParent: StreamingGuidanceCatalog.StreamingOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How to use the Sound Level Meter tool?",
        catchwords: ["setting up measurement setup", "demo’s", "first quick analysis"],
    };
    static StreamingGS3Module: IGuidanceTopic = {
        name: "Streaming_Q3", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720175734/S3+What+am+I+seeing+in+the+Near+Field+stream
        modulePath: PLATFORM.moduleName("guidance/Streaming/S3WhatAmISeeingInNearFieldStream.html"),
        title: "Streaming",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoRealTimeRecording),
        topicParent: StreamingGuidanceCatalog.StreamingOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What am I seeing in the Near Field stream?",
        catchwords: ["", ""],
    };

    static StreamingGS4Module: IGuidanceTopic = {
        name: "Streaming_Q4", // https://sorama.atlassian.net/wiki/spaces/UI/pages/745079922/S4+How+do+I+pin+the+correct+upper-+and+lower+pressure+values
        modulePath: PLATFORM.moduleName("guidance/Streaming/S4HowToPinCorrectPressureValues.html"),
        title: "Streaming",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoRealTimeRecording),
        topicParent: StreamingGuidanceCatalog.StreamingOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How do I pin the correct upper- and lower pressure values?",
        catchwords: ["", "", ""],
    };
    static StreamingGS6Module: IGuidanceTopic = {
        name: "Streaming_Q6", //https://sorama.atlassian.net/wiki/spaces/UI/pages/830341198/S6+What+is+frequency+weighting
        modulePath: PLATFORM.moduleName("guidance/Streaming/S6WhatIsFrequencyWeighting.html"),
        title: "Frequency Weighting",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoRealTimeRecording),
        topicParent: StreamingGuidanceCatalog.StreamingOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What is frequency weighting?",
    };

    static StreamingGS8Module: IGuidanceTopic = {
        name: "Streaming_Q8",
        modulePath: PLATFORM.moduleName("guidance/Streaming/S8WhatIsWindowLength.html"),
        title: "Time Window length",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All.filter((mode) => mode.canDoRealTimeRecording),
        topicParent: StreamingGuidanceCatalog.StreamingOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What is window length?",
    };
}
